var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallInfoContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99931 14.9586C8.30804 13.7533 7.97426 12.769 7.77301 11.7713C7.47535 10.2958 8.15653 8.85436 9.28497 7.93464C9.76189 7.54593 10.3086 7.67874 10.5906 8.18469L11.2273 9.32694C11.732 10.2323 11.9843 10.685 11.9343 11.1649C11.8842 11.6449 11.5439 12.0358 10.8633 12.8175L8.99931 14.9586ZM8.99931 14.9586C10.3985 17.3984 12.5943 19.5953 15.0368 20.9961M15.0368 20.9961C16.2422 21.6874 17.2264 22.0212 18.2241 22.2224C19.6997 22.5201 21.1411 21.8389 22.0608 20.7105C22.4495 20.2336 22.3167 19.6868 21.8108 19.4048L20.6685 18.7681C19.7631 18.2635 19.3104 18.0111 18.8305 18.0612C18.3506 18.1112 17.9597 18.4515 17.1779 19.1321L15.0368 20.9961Z",
    stroke: "#2177FE",
    strokeWidth: 1.09375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 11.2322C17.4909 11.6729 18.3226 12.5045 18.7633 13.5423M16.93 7.70898C19.5092 8.45329 21.5421 10.486 22.2865 13.0652",
    stroke: "#2177FE",
    strokeWidth: 1.09375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallInfoContainer);
export default __webpack_public_path__ + "static/media/callInfoContainer.b62a5b5ee045aa99c75e094298449695.svg";
export { ForwardRef as ReactComponent };